import { PaginationResponse } from "./../types/api.types";

export const initialPageParam = "0";

export const getNextPageParam = <T>(lastPage: PaginationResponse<T>) => {
  if (lastPage.next) {
    // Extract the offset from the 'next' URL
    const url = new URL(lastPage.next);
    const offset = url.searchParams.get("offset");
    return offset ? offset : undefined;
  }

  return undefined;
};

export const getPreviousPageParam = <T>(firstPage: PaginationResponse<T>) =>
  firstPage.previous || undefined;
